// extracted by mini-css-extract-plugin
module.exports = {"container":"TrustPilotTwoLinesWidget_container__I6JpE","stats":"TrustPilotTwoLinesWidget_stats__qFuIv"};